import { styled, darken, Container } from '@mui/material'

const AppWrapperStyled = styled(Container, {
  name: 'AppWrapper'
})(({ theme }) => ({
  overflow: 'hidden',
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  padding: 0,
  color: theme.palette.text.primary,
  backgroundColor: darken(theme.palette.background.default, 0.05)
}))

AppWrapperStyled.defaultProps = {
  maxWidth: false,
  disableGutters: true
}

export default AppWrapperStyled
